<template>
    <div>
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>系统设置</el-breadcrumb-item>
            <el-breadcrumb-item>版本管理</el-breadcrumb-item>
        </el-breadcrumb>

        <!-- Tabs -->
        <el-tabs v-model="activeName" type="border-card">
          <!-- 筛选条件 start -->
          <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
            <el-form-item>
              <el-button type="primary" @click="clicksearch">查询</el-button>
            </el-form-item>
          </el-form>
          <!-- 筛选条件 end -->
            <!-- 版本信息列表 strat -->
            <el-tab-pane name="first" label="版本信息列表">
                <el-table :data="versionInfo" border stripe>
                    <el-table-column prop="versioncode" label="版本号" width="80px"></el-table-column>
                    <el-table-column prop="url" label="存储路径" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column prop="miaoshu" label="描述" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column prop="typename" label="类型" width="200px"></el-table-column>
                    <el-table-column prop="operation" label="操作" width="200px">
                      <template v-slot="scope">
                        <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickmodify(scope.$index,scope.row)">修改</el-button>
                        <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="removeVersion(scope.$index,scope.row)">删除</el-button>
                      </template>
                    </el-table-column>
                </el-table>

                <!-- 修改固件版本弹出框 start -->
                <el-dialog title="修改固件版本" :visible.sync="modify" width="30%" :close-on-click-modal="false">
                    <el-form :model="editVersion" ref="editVersionRef" label-width="70px">
                        <el-form-item label="类型" class="addAdminForm">
                            <el-input v-model="editVersion.typename" placeholder="睿科技门店IOS" disabled></el-input>
                        </el-form-item>

                        <el-form-item label="版本号" class="addAdminForm">
                            <el-input v-model="editVersion.versioncode" placeholder="请输入版本号"></el-input>
                        </el-form-item>

                        <el-form-item label="存储路径" class="addAdminForm">
                            <el-input v-model="editVersion.url" placeholder="请输入存储路径"></el-input>
                        </el-form-item>

                        <el-form-item label="备注" class="addAdminForm">
                            <el-input type="textarea" v-model="editVersion.miaoshu" placeholder="请输入描述"></el-input>
                        </el-form-item>

                        <el-form-item>
                            <el-button type="primary" @click="clickedit">保存</el-button>
                        </el-form-item>
                    </el-form>
                </el-dialog>
                <!-- 修改固件版本弹出框 end -->

            </el-tab-pane>
            <!-- 版本信息列表 end -->

            <!-- 添加固件版本 start -->
            <el-tab-pane name="second" label="添加固件版本">
                <el-form :model="addVersion" ref="addVersionRef" label-width="70px">
                    <el-form-item label="类型" class="addAdminForm">
                        <el-input v-model="addVersion.typename" placeholder="固件" disabled=""></el-input>
                    </el-form-item>

                    <el-form-item label="版本号" class="addAdminForm">
                        <el-input v-model="addVersion.versioncode" placeholder="请输入版本号"></el-input>
                    </el-form-item>

                    <el-form-item label="存储路径" class="addAdminForm">
                        <el-input v-model="addVersion.url" placeholder="请输入存储路径"></el-input>
                    </el-form-item>

                    <el-form-item label="描述" class="addAdminForm">
                        <el-input type="textarea" v-model="addVersion.miaoshu" placeholder="请输入描述"></el-input>
                    </el-form-item>

                    <el-form-item>
                        <el-button type="primary" @click="clickadd">添加</el-button>
                        <el-button type="info" @click="clickreturn">返回</el-button>
                    </el-form-item>
                </el-form>
            </el-tab-pane>
            <!-- 添加固件版本 end -->
        </el-tabs>
    </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  name: 'MyVersion',
  data () {
    return {
      activeName: 'first',
      addVersion: {
        typename: '固件',
        versioncode: '',
        url: '',
        miaoshu: ''
      },
      editVersion: {
        versionid: '',
        typename: '',
        versioncode: '',
        url: '',
        miaoshu: ''
      },
      versionInfo: [],
      modify: false,
      keywords: {
        jigouid: '-1',
        jigouname: ''
      }
    }
  },
  mounted () {
    this.apigetversionlist()
  },
  methods: {
    clicksearch () {
      this.apigetversionlist()
    },
    removeVersion (index, row) {
      this.$confirm('是否删除此版本信息?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.apideleteversion(row.id)
      })
    },
    clickadd () {
      if (!this.addVersion.versioncode) {
        this.$alert('请输入版本号', '提示')
        return
      }
      if (!this.addVersion.url) {
        this.$alert('请输入存储路径', '提示')
        return
      }
      if (!this.addVersion.miaoshu) {
        this.$alert('请输入描述', '提示')
        return
      }
      this.apiaddversion()
    },
    clickreturn () {
      this.activeName = 'first'
    },
    clickmodify (index, row) {
      this.editVersion.versionid = row.id
      this.editVersion.typename = row.typename
      this.editVersion.versioncode = row.versioncode
      this.editVersion.url = row.url
      this.editVersion.miaoshu = row.miaoshu
      this.modify = true
    },
    clickedit () {
      if (!this.editVersion.versioncode) {
        this.$alert('请输入版本号', '提示')
        return
      }
      if (!this.editVersion.url) {
        this.$alert('请输入存储路径', '提示')
        return
      }
      if (!this.editVersion.miaoshu) {
        this.$alert('请输入描述', '提示')
        return
      }
      this.apieditversion()
    },
    apigetversionlist: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint()
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Getversionlist, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code == 200) {
            that.versionInfo = []
            response.data.List.filter((item1, i1) => {
              that.versionInfo.push({ id: item1.Id, versioncode: item1.Versioncode, url: item1.Url, miaoshu: item1.Miaoshu, typename: item1.Typename })
            })
          }
		  Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiaddversion: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        versioncode: this.addVersion.versioncode,
        url: this.addVersion.url,
        miaoshu: this.addVersion.miaoshu
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Addversion, Qs.stringify(data))
        .then(function (response) {
          that.apigetversionlist()
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apieditversion: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        versionid: this.editVersion.versionid,
        versioncode: this.editVersion.versioncode,
        url: this.editVersion.url,
        miaoshu: this.editVersion.miaoshu
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Editversion, Qs.stringify(data))
        .then(function (response) {
          that.apigetversionlist()
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.modify = false
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apideleteversion: function (versionid) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        versionid: versionid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Deleteversion, Qs.stringify(data))
        .then(function (response) {
          that.apigetversionlist()
          Vue.prototype.FunCheckApiCode(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>

</style>
